import type {
  SelectionSetManifest,
  SelectionSetSummary,
  SelectionSetVersion,
  SelectionSetDiff,
} from '@stride/shared'
import type {
  ISelectionSetService,
  SaveSelectionSetParams,
  UpdateSelectionSetParams,
} from './ISelectionSetService.interface'

/** Canned data so the UI renders without a running API. Nothing persists. */
const DEMO_MANIFEST: SelectionSetManifest = {
  name:        'ARM Core Working Set',
  slug:        'arm-core-working-set',
  description: 'Representative ARM Revenue Cloud components.',
  tags:        ['arm', 'revenue-cloud'],
  author:      'demo',
  createdAt:   '2026-06-01T08:00:00.000Z',
  updatedAt:   '2026-06-02T09:30:00.000Z',
  version:     2,
  components: [
    { type: 'ApexClass',    fullName: 'AttributeService' },
    { type: 'CustomField',  fullName: 'Attribute__c.DataType__c' },
    { type: 'Flow',         fullName: 'ARM_Pricing_Flow' },
  ],
}

function slugify(input: string): string {
  return input.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
}

export class MockSelectionSetService implements ISelectionSetService {
  list(): Promise<SelectionSetSummary[]> {
    const summary: SelectionSetSummary = {
      slug:           DEMO_MANIFEST.slug,
      name:           DEMO_MANIFEST.name,
      tags:           DEMO_MANIFEST.tags,
      updatedAt:      DEMO_MANIFEST.updatedAt,
      componentCount: DEMO_MANIFEST.components.length,
      latestVersion:  2,
      ...(DEMO_MANIFEST.description !== undefined && { description: DEMO_MANIFEST.description }),
      ...(DEMO_MANIFEST.author !== undefined && { author: DEMO_MANIFEST.author }),
    }
    return Promise.resolve([summary])
  }

  get(_slug: string, _version?: number): Promise<SelectionSetManifest> {
    void _slug; void _version
    return Promise.resolve(DEMO_MANIFEST)
  }

  save(params: SaveSelectionSetParams): Promise<{ slug: string; version: number }> {
    return Promise.resolve({ slug: slugify(params.name), version: 1 })
  }

  update(slug: string, _params: UpdateSelectionSetParams): Promise<{ slug: string; version: number }> {
    void _params
    return Promise.resolve({ slug, version: 2 })
  }

  versions(_slug: string): Promise<SelectionSetVersion[]> {
    void _slug
    return Promise.resolve([
      { version: 2, author: 'demo', timestamp: '2026-06-02T09:30:00.000Z', note: 'update' },
      { version: 1, author: 'demo', timestamp: '2026-06-01T08:00:00.000Z', note: 'save v1' },
    ])
  }

  diff(_slug: string, _base: number, _head: number): Promise<SelectionSetDiff> {
    void _slug; void _base; void _head
    return Promise.resolve({
      added:   [{ type: 'Flow', fullName: 'ARM_Pricing_Flow' }],
      removed: [],
    })
  }
}
